module.exports = require("@workbench-stack/layout");